import { render, staticRenderFns } from "./level-score-table.vue?vue&type=template&id=24d72a4a&"
import script from "./level-score-table.vue?vue&type=script&lang=js&"
export * from "./level-score-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports